import Vue from 'vue'
import App from './App.vue'
import router from './router'

import './assets/iconfont/iconfont.css';
import './common/css/style.less'
import './common/css/resetTraWeb.less'

import './assets/theme/index.css'
import ElementUI from 'element-ui'
/* import 'element-ui/lib/theme-chalk/index.css' */
Vue.use(ElementUI);

import 'tra-web/lib/theme-default/index.css'
import TraWeb from 'tra-web'
Vue.use(TraWeb)

import store from './store'

import global from './utils/global'
Vue.use(global)

import commonUtil from "@/common/js/common.js";
Vue.prototype.$commonUtil = commonUtil;

var sensors = require('sa-sdk-javascript');
sensors.init({
  server_url: window['SCMD_URL'],
  is_track_single_page:true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time:true,
  send_type:'beacon',
  show_log:false,
  heatmap: {
		//是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
		clickmap:'not_collect',
		//是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
		scroll_notice_map:'not_collect',
    collect_tags:{
      div : true,
      li: true
    }
  }
});
// 注册公共属性
sensors.registerPage({
	system_code: 'EOS-TBP-CORE',
	platform_type: 'web',
	platform_name: 'SLHZ',
  $app_name:"SAAS货主"
});
sensors.quick('autoTrack'); //用于采集 $pageview 事件。
Vue.prototype.$sensors = sensors;

// Vue.directive('track', {
//   bind(el, binding) {
//     el.addEventListener('click', () => {
//       let data = binding.value;
//       SfGather.add_event({event_id: data.action});
//     }, false);
//   }
// });
Vue.directive('track', {
  bind(el, binding) {
    el.addEventListener('click', () => {
      let data = binding.value;
      sensors.track('SaasPageClick',{
        event_click_name: data.action
      });
    }, false);
  }
});

Vue.directive('limitNum',{
  bind(el,binding){
    el.addEventListener('input',()=>{
      const ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
      ele.value = ele.value.replace(/[^0-9]/g,'')
    },false)
  }
});
Vue.directive('numG',{
  bind(el,binding){
    el.addEventListener('input',()=>{
      const ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
      let reg = new RegExp("^[0-9.]*$");
      if (!reg.test(ele.value)) {
        ele.value = ele.value.replace(/[^0-9.]/g,'')
        ele.dispatchEvent(new Event("input"));
      }
    },false)
  }
});

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
